import Catalog17 from "../../assets/img/car-finder/catalog/17.jpg";
import Catalog09 from "../../assets/img/car-finder/catalog/09.jpg";
import { useContext, useEffect, useState,useRef } from "react";
import {
  addCarToWishlist,
  fetchCardetails,
  fetchCars
} from "../../_services/carsService";
import { Link,NavLink } from "react-router-dom";
import { useParams } from "react-router-dom";
import { Alert, Card, Spinner } from "react-bootstrap";
import Avatar from "../../assets/img/avatars/01.jpg";
import AddToWishListBtn from "../../components/addToWishListBtn";
import { AuthContext } from "../../context/AuthContext";
import { ToastContext } from "../../context/ToastContext";
import PlaceBidModal from "../../components/PlaceBidModal";
import Slider from "react-slick";
import StickyBidCard from "./StickyBidCard";

import ExpandableText from "./ExpandableText";
import CommentSection from "./CommentSection";
import { FaClock,FaCrown,FaUser } from "react-icons/fa";
import Countdown from 'react-countdown';
import AskSellarQuestion from "./AskSellarQuestion";
import ImageSliderModal from "../../components/ImageSliderModal";
import { fetchQuestionsAndAnswers } from "../../_services/carsService";
import QnASection from "./QuestionAndAnswers";
import AdBanner from "./AdBanner";


const CarViewPage = () => {
  const { id } = useParams();
  const { isLoggedIn, login, userInfo } = useContext(AuthContext);
  const { showToast } = useContext(ToastContext);

  const [car, setCar] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showPlaceBidModal, setShowPlaceBidModal] = useState(false);
  const [bidStatus, setBidStatus] = useState(false);
  const [currentBid, setCurrentBid] = useState({});
  const [highestBid, setHighestBid] = useState(0);
  const handleCloseBidModal = () => setShowPlaceBidModal(false);
  {/* Cars which are expiring soon*/}
  const [expiringSoonCars, setExpiringSoonCars] = useState([]);
{/* Cars which are latest arrivals*/}
  const [latestArrivals, setLatestArrivals] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [currentImages, setCurrentImages] = useState([]);
  const [modalTitle, setModalTitle] = useState('');
  //scrolling to comment section
  const commentSectionRef = useRef(null);
  // setting the comments section
  const [commentsCount, setCommentsCount] = useState(0);
  // questions and answers of sellers
  const [questions, setQuestions] = useState([]);

  //fetching the list of questions and answers
  useEffect(() => {
    const getQuestionAnswers = async () => {
      try {
        const data = await fetchQuestionsAndAnswers(id);
        setQuestions(Array.isArray(data.questions_with_answers) ? data.questions_with_answers : []);

      } catch (err) {
        setError(err);
        showToast("Failed to fetch questions and answers.", "danger");
      } finally {
        setLoading(false);
      }
    };
  
    getQuestionAnswers(); // Call API when component mounts
  }, []);

  //handling new question when added
  const handleNewQuestion = (newQuestionText) => {
    const now = new Date();

    const newQuestion = {
      asked_by: userInfo.email,
      created_at: now,
      content: newQuestionText,
      answer: "Seller has been notified and your query will be answered soon. Thanks for the patience"
    };

    setQuestions((prevQuestions) => [newQuestion, ...prevQuestions]); // add new question to top
  };


  {/* Fetching the latest arrivals */}
  useEffect(() => {
    const getExpiringCars = async () => {
      try {
        const data = await fetchCars();
        setLatestArrivals(data);
      } catch (err) {
        setError(err);
        showToast("Failed to load cars.", "danger");
      } finally {
        setLoading(false);
      }
    };
  
    getExpiringCars(); // Call API when component mounts
  }, []);
  {/* Fetch the expiring soon cars on use effect*/}
  useEffect(() => {
    const getExpiringCars = async () => {
      try {
        const data = await fetchCars();
        setExpiringSoonCars(data);
      } catch (err) {
        setError(err);
        showToast("Failed to load cars.", "danger");
      } finally {
        setLoading(false);
      }
    };
  
    getExpiringCars(); // Call API when component mounts
  }, []);
  const fetchCar = async () => {
    try {
      const data = await fetchCardetails(id);
      //console.log(data);

      setCar(data);
    } catch (err) {
      setError(err);
      showToast("Failed to load Car details.", "danger");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    //console.log(userInfo);

    fetchCar();
  }, [id]);

  // when event is triggered from the LoginModal.
  useEffect(() => {
    const handleOpenBidModal = () => {
      setShowPlaceBidModal(true);
    };
  
    window.addEventListener("openPlaceBidModal", handleOpenBidModal);
  
    return () => {
      window.removeEventListener("openPlaceBidModal", handleOpenBidModal);
    };
  }, []);

  const handlePlaceBid = async () => {
    if (isLoggedIn) {
      if (car.seller_email === userInfo?.email) {
        alert("You cannot bid on your own car.");
        return;
      }
      setShowPlaceBidModal(true);
    } else {
      // adding the showPlaceBidModal, so that after successfull login we open the bid modal
      localStorage.setItem("postLoginAction", "showPlaceBidModal");
      const loginEvent = new Event("openLoginModal");
      window.dispatchEvent(loginEvent); // Dispatch global event
      return;
    }
  };
  

  const getSliderSettings = (images) => ({
    infinite: images?.length > 1,
    slidesToShow: 1,
    arrows: true,
    className: "slides",
    slidesToScroll: 1,
  });
  const ImageMapper = (image, id) => {
    return (
      <div key={id} className="position-relative">
        {/* Overlay for the wishlist button */}
        <div className="position-absolute end-0 top-0 pt-3 pe-3 z-3">
          <AddToWishListBtn car={car} />
        </div>
        
        {/* Image */}
        <img
          src={image.image_url}
          alt="Car Image"
          className="w-100 rounded"
          style={{ width: '300px', height: '500px', objectFit: 'contain' }} 
        />
      </div>
    );
  };

  const getSectionData = (sections, sectionName) => {
    // Find the section that matches the section_name provided
    const section = sections.find(sec => sec.section_name === sectionName);
  
    // If the section is found, return its data, otherwise return default empty values
    if (section) {
      const result = {
        section_name: section.section_name,
        description: section.description || "",  // Ensure description is not undefined
        items: section.items ? section.items.split(',').map(item => item.trim()) : [] // Split the items by comma
      };
      return  result;
    } else {
      // Return default value if section not found
      return {
        section_name: sectionName,
        description: "",
        items: []
      };
    }
  };

  const openModal = (images, title) => {
    setCurrentImages(images);
    setModalTitle(title);
    setModalOpen(true);
  };
  const closeModal = () =>{
    setCurrentImages([]);
    setModalTitle("")
    setModalOpen(false);
  }

  //scrolling to comments
  const scrollToComments = () => {
    if (commentSectionRef.current) {
      commentSectionRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section>
      {car && car.id && <PlaceBidModal
        show={showPlaceBidModal}
        car={car}
        handleClose={handleCloseBidModal}
        handleSubmit={(e) => {
          e.preventDefault();
         // console.log("Login Submitted!");
        }}
        bidStatus={bidStatus}
        setBidStatus={setBidStatus}
        currentBid={currentBid}
        setCurrentBid={setCurrentBid}
        fetchCar={fetchCar}
      />}

      {loading && (
        <div
          className="my-5 py-5 w-100 d-flex justify-content-center align-items-center"
          style={{ minHeight: "100vh" }}
        >
          <span className="loader"></span>
        </div>
      )}
      {error && <Alert variant="danger">{error}</Alert>}

      {car && car.id && (
        <div className="container py-5 mt-5"  style={{ marginLeft: "70px" }}>
          <nav className="py-2" aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <NavLink to="/auctions">Auctions</NavLink>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                {car.make} {car.model}
              </li>
            </ol>
          </nav>

          <div className="d-flex justify-content-between gap-3 position-relative z-2 mb-3 mb-lg-4">
            <h2 className="mb-0">
              {car.year} {car.make} {car.model}
            </h2>
            
          </div>

          <div className="row"  >
            <div className="col-lg-8 pb-6 pb-sm-0 mb-4 mb-sm-5 mb-lg-0">
              <div className="d-flex gap-3 align-items-start">
                <div className="flex-grow-1" style={{ minWidth: 0}} >
                  <Slider {...getSliderSettings(car?.display_image)}>
                    {car.display_image.map((image, id) => {
                      return ImageMapper(image, id);
                    })}
                  </Slider>
                  {/* <img src={`https://xlr8.sg/${car.images[0].image_url.split("/").slice(-3).join("/")}`} alt="Image" className="rounded" /> */}
                </div>
              </div>
              {/*
                Using the bootstrap sticky-top has done the smooth stickiness and i have remvoe the react sticky component
                from the StickBidCard 
              */}
              <div className="sticky-top" style={{ top: '80px', zIndex: 1030 }}>
                <StickyBidCard 
                    car={car} 
                    bidStatus={true} 
                    currentBid={{ bid_amount: 5000 }} 
                    handlePlaceBid={handlePlaceBid} 
                    onCommentsClick={scrollToComments}
                    commentsCount={commentsCount} // Passing comments count here
                />
              </div>
             
              <h2 className="h3 pt-5 mt-sm-2 my-lg-4">Specifications</h2>
              
              <table className="table table-bordered">
                  <tbody>
                    <tr>
                      <th className="bg-body-tertiary text-sm font-light">Manufactured Year</th>
                      <td>{car.manufacturing_year}</td>
                      <th  className="bg-body-tertiary">Registration Year</th>
                      <td>{car.reg_year}</td>
                    </tr>
                    <tr>
                      <th  className="bg-body-tertiary">Depreciation ($)</th>
                      <td>{car.depreciation}</td>
                      <th  className="bg-body-tertiary">Mileage</th>
                      <td>{car.mileage}</td>
                    </tr>
                    <tr>
                      <th  className="bg-body-tertiary">Engine Cap</th>
                      <td>{car.engine_cap}</td>
                      <th  className="bg-body-tertiary">Road Tax ($)</th>
                      <td>{car.road_tax}</td>
                    </tr>
                    <tr>
                      <th  className="bg-body-tertiary">Dereg Value ($)</th>
                      <td>{car.dereg_value}</td>
                      <th  className="bg-body-tertiary">COE</th>
                      <td>{car.coe}</td>
                    </tr>
                    <tr>
                      <th  className="bg-body-tertiary">OMV ($)</th>
                      <td>{car.omv}</td>
                      <th  className="bg-body-tertiary">ARF ($)</th>
                      <td>{car.arf}</td>
                    </tr>
                    <tr>
                      <th  className="bg-body-tertiary">No. of Owners</th>
                      <td>{car.num_owners}</td>
                      <th  className="bg-body-tertiary">Power (bhp)</th>
                      <td>{car.power}</td>
                    </tr>
                    <tr>
                      <th  className="bg-body-tertiary">Curb Weight (Kg)</th>
                      <td>{car.curb_weight}</td>
                      <th className="bg-body-tertiary">Transmission</th>
                      <td>{car.transmission}</td>
                    </tr>
                  </tbody>
              </table>
              
              <div className="d-flex flex-row mt-5">
                  <div className="d-flex flex-column" style={{ flex: 1, marginRight: '20px' }}>
                  <ExpandableText
                      title="Highlights"
                      description={getSectionData(car.sections, "highlights").description}
                      items={getSectionData(car.sections, "highlights").items} 
                    />
                </div>
                  
                <div className="d-flex flex-column" style={{ flex: 1 }}>
                    <ExpandableText
                      title="Equipments"
                      description={getSectionData(car.sections, "equipments").description}
                      items={getSectionData(car.sections, "equipments").items}                    
                       />
                </div>
              </div>
              <div className="d-flex flex-row mt-5">
              <div className="d-flex flex-column" style={{ flex: 1, marginRight: '20px' }}>
                  <ExpandableText
                   title="Modifications"
                   description={getSectionData(car.sections, "modification").description}
                   items={getSectionData(car.sections, "modification").items}  
                   />
                </div>
                
                <div className="d-flex flex-column" style={{ flex: 1 }}>
                  <ExpandableText
                    title="KnownFlaws"
                    description={getSectionData(car.sections, "known_flaws").description}
                   items={getSectionData(car.sections, "known_flaws").items}  
                  />
                </div>
              </div>

              <div className="d-flex flex-row mt-5">
              <div className="d-flex flex-column" style={{ flex: 1, marginRight: '20px' }}>
                  <ExpandableText
                    title="Recent Service History"
                    description={getSectionData(car.sections, "service_history").description}
                   items={getSectionData(car.sections, "service_history").items}
                  />
                </div>
                
                <div className="d-flex flex-column" style={{ flex: 1 }}>
                  <ExpandableText
                    title="Other items included in sale"
                    description={getSectionData(car.sections, "other_items").description}
                    items={getSectionData(car.sections, "other_items").items}
                  />
                </div>
              </div>
              
              <div className="d-flex flex-row mt-5">
              <div className="d-flex flex-column" style={{ flex: 1, marginRight: '20px' }}>
                  <ExpandableText
                    title="Ownership History"
                    description={getSectionData(car.sections, "ownership_history").description}
                    items={getSectionData(car.sections, "ownership_history").items}                  
                  />
                </div>
                
                <div className="d-flex flex-column" style={{ flex: 1 }}>
                  <ExpandableText
                    title="Sellar Notes"
                    description={getSectionData(car.sections, "seller_notes").description}
                    items={getSectionData(car.sections, "seller_notes").items}  
                  />
                </div>
              </div>
                 
              {/* Ask Sellar block */}
              <div className="mt-4">
                <h4 className="text-lg font-semibold mb-2">Seller Q/A </h4>
              </div>
              <div className="d-flex flex-row mt-2 gap-4">
                {/* Seller Q/A Section */}
                
                <QnASection questions={questions}/>
                {/* Ask question to sellar*/}
                <AskSellarQuestion onSubmitQuestion={handleNewQuestion} car={car} />
              </div>
         
               {/* Ad banner */}
               <AdBanner/>
              {/* Comment Section */}
             <CommentSection car={car} ref={commentSectionRef}  setCommentsCount={setCommentsCount} /> 
             <div style={{ height: '80px' }}></div> {/* buffer before footer */}
              
            </div>
            <div className="col-lg-4">
            <div className="row g-2">
                    {[
                      {
                        label: `Exterior (${car.exterior_images.length})`,
                        image: car.exterior_images[0]?.image_url,
                        images: car.exterior_images.map((img) => img.image_url),
                      },
                      {
                        label: `Interior (${car.interior_images.length})`,
                        image: car.interior_images[0]?.image_url,
                        images: car.interior_images.map((img) => img.image_url),
                      },
                      {
                        label: `Documents (${car.ownership_images.length})`,
                        image: car.ownership_images[0]?.image_url,
                        images: car.ownership_images.map((img) => img.image_url),
                      },
                      {
                        label: `All (${car.exterior_images.length + car.interior_images.length + car.ownership_images.length})`,
                        image: [
                          ...car.exterior_images,
                          ...car.interior_images,
                          ...car.ownership_images,
                        ][0]?.image_url,
                        images: [
                          ...car.exterior_images,
                          ...car.interior_images,
                          ...car.ownership_images,
                        ].map((img) => img.image_url),
                      },
                    ].map((item, index) => (
                      <div className="col-6" key={index}>
                        <div
                          className="position-relative rounded overflow-hidden"
                          style={{ height: '250px', cursor: 'pointer' }}
                          onClick={() => openModal(item.images, item.label)}
                        >
                          <div
                            style={{
                              backgroundImage: `url(${item.image})`,
                              backgroundSize: 'cover',
                              backgroundPosition: 'center',
                              height: '100%',
                              width: '100%',
                            }}
                          />
                          <div className="position-absolute top-0 start-0 bg-dark bg-opacity-75 text-white px-2 py-1 small rounded-end">
                            {item.label}
                          </div>
                        </div>
                      </div>
                    ))}
                    <ImageSliderModal
                      isOpen={modalOpen}
                      onClose={() => closeModal()}
                      images={currentImages}
                      title={modalTitle}
                    />
              </div>
              <div className="d-flex flex-row mt-4 text-bold justify-content-center">
                <h3 className="h3 mt-sm-2 text-center">Expiring soon</h3>
              </div>
              <div className="row g-2 mt-6">
                  {/* Iterate over the list of cars */}
                  {expiringSoonCars.map((car, index) => (
                 
                    <div className="col-6" key={index}>
                      <div className="position-relative rounded overflow-hidden" style={{ height: '100px' }}>
                        {/* Background Image */}
                        <Link
                            className="text-decoration-none"
                            key={index}
                            to={`/auctions/${car.id}`}
                          >
                        <div
                          style={{
                            backgroundImage: `url(${car.display_image[0]?.image_url})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            height: '100%',
                            width: '100%',
                          }}
                        />
                         </Link>
                        {/* Label */}
                        <div className="position-absolute top-0 start-0 bg-dark bg-opacity-75 text-white px-2 py-1 small rounded-end">
                          {car.model} {/* Assuming 'model' is a property in the car object */}
                        </div>
                        <div
                            className="position-absolute bottom-0 start-0 end-0 bg-dark bg-opacity-70 text-white px-2 py-1 d-flex justify-content-between align-items-center"
                          >
                            {/* Left side - clock and countdown */}
                            <span className="d-flex align-items-center">
                              <FaClock className="text-primary me-1" style={{ fontSize: "12px" }} />
                              <span style={{ fontSize: "12px" }}>
                                <Countdown
                                  date={Date.now() + 100000}
                                  renderer={(props) => (
                                    <>
                                      {props.hours}:{props.minutes}:{props.seconds}
                                    </>
                                  )}
                                />
                              </span>
                            </span>

                            {/* Right side - crown */}
                            <span>
                              <FaCrown className="text-warning" style={{ fontSize: "12px" }} />
                              <span style={{ fontSize: "12px" }}>
                                ${car.current_bid_amount?.toLocaleString()}
                              </span>
                            </span>
                        </div>
                      </div>
                    </div>
                   
                  ))}
                </div>

              <div className="d-flex flex-row mt-4 text-bold justify-content-center">
                <h3 className="h3 mt-sm-2 text-center">Latest Arrivals</h3>
              </div>
              <div className="row g-2 mt-6">
                  {/* Iterate over the list of cars */}
                  {latestArrivals.map((car, index) => (
                 
                    <div className="col-6" key={index}>
                      <div className="position-relative rounded overflow-hidden" style={{ height: '100px' }}>
                        {/* Background Image */}
                        <Link
                                          className="text-decoration-none"
                                          key={index}
                                          to={`/auctions/${car.id}`}
                                        >
                        <div
                          style={{
                            backgroundImage: `url(${car.display_image[0]?.image_url})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            height: '100%',
                            width: '100%',
                          }}
                        />
                         </Link>
                        {/* Label */}
                        <div className="position-absolute top-0 start-0 bg-dark bg-opacity-75 text-white px-2 py-1 small rounded-end">
                          {car.model} {/* Assuming 'model' is a property in the car object */}
                        </div>
                        {/* Bottom-left "NEW" box */}
                        <div className="position-absolute bottom-0 start-0 bg-primary text-white px-2 py-1 small " style={{
                            borderRadius: '20px',
                            fontSize: "12px" ,
                            cursor: 'pointer',
                            height: '20px', // Set a fixed height for the button
                            width: 'auto', // Auto width to adjust based on padding
                            lineHeight: '16px', // Make sure text is vertically centered
                          }}>
                          NEW
                        </div>
                        
                      </div>
                    </div>
                   
                  ))}
                </div>
                
            </div>
          
           

            {/* <!-- Sidebar with car detail and seller info --> */}
            <aside className="col-lg-4" style={{ marginTop: "-110px" }}>
              <div
                className="position-sticky top-0"
                style={{ paddingTop: "110px" }}
              >
                {/* <!-- Seller info card --> */}
                
              </div>
            </aside>
          </div>
         
        </div>
       
      )}
    </section>
  );
};

export default CarViewPage;
